import type { AxiosResponse } from 'axios';

import apiRequest from '.';
import { JSONObject } from '../types';
import { getUserData } from './getUserData';
import { ApiRequestArgsOptionalUserData } from './types';

export const browserApiRequest = <T = JSONObject>(
	args: ApiRequestArgsOptionalUserData,
): Promise<AxiosResponse<T>> => {
	return apiRequest<T>({
		userData: getUserData(),
		...args,
	});
};
